import axios from "axios";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { FnAxios, FnDialog, IsNullOrUndefined } from "utilities/utilities";
import _ from "lodash";

export function useInitCompareExpenses({ data, arrYear }) {

    // const arrInitExpensesLineChart = [
    //     {
    //         "sMonth": "ม.ค.",
    //         "Y2565": "2.5",
    //         "Y2566": "1",
    //         "Y2567": "3.4"
    //     },
    //     {
    //         "sMonth": "ก.พ.",
    //         "Y2565": "0.5",
    //         "Y2566": "1.8",
    //         "Y2567": "1.1"
    //     },
    //     {
    //         "sMonth": "มี.ค.",
    //         "Y2565": "1",
    //         "Y2566": "0.3",
    //         "Y2567": "1.8"
    //     },
    //     {
    //         "sMonth": "เม.ย.",
    //         "Y2565": "1.7",
    //         "Y2566": "0.7",
    //         "Y2567": "2.8"
    //     },
    //     {
    //         "sMonth": "พ.ค.",
    //         "Y2565": "0.9",
    //         "Y2566": "1.3",
    //         "Y2567": "0.4"
    //     },
    //     {
    //         "sMonth": "มิ.ย.",
    //         "Y2565": "2.5",
    //         "Y2566": "2.1",
    //         "Y2567": "1.6"
    //     },
    //     {
    //         "sMonth": "ก.ค.",
    //         "Y2565": "0.2",
    //         "Y2566": "1.6",
    //         "Y2567": "2.4"
    //     },
    //     {
    //         "sMonth": "ส.ค.",
    //         "Y2565": "1",
    //         "Y2566": "1.7",
    //         "Y2567": "2.1"
    //     },
    //     {
    //         "sMonth": "ก.ย.",
    //         "Y2565": "0.6",
    //         "Y2566": "1.5",
    //         "Y2567": "1"
    //     },
    //     {
    //         "sMonth": "ต.ค.",
    //         "Y2565": "0.8",
    //         "Y2566": "1.2",
    //         "Y2567": "0.01"
    //     },
    //     {
    //         "sMonth": "พ.ย.",
    //         "Y2565": "1.9",
    //         "Y2566": "1",
    //         "Y2567": "1.4"
    //     },
    //     {
    //         "sMonth": "ธ.ค.",
    //         "Y2565": "0.09",
    //         "Y2566": "0.5",
    //         "Y2567": "1.5"
    //     }
    // ];

    // let nResult65 = arrInitExpensesLineChart.map(m => parseInt(m.Y2565)).reduce((a, b) => {
    //     return a + b
    // }, 0) * 1000000;
    // let nResult66 = arrInitExpensesLineChart.map(m => parseInt(m.Y2566)).reduce((a, b) => {
    //     return a + b
    // }, 0) * 1000000;
    // let nResult67 = arrInitExpensesLineChart.map(m => parseInt(m.Y2567)).reduce((a, b) => {
    //     return a + b
    // }, 0) * 1000000;

    // let nBudget65 = nResult65 + (nResult65 * 0.105);
    // let nBudget66 = nResult66 + (nResult66 * 0.25);
    // let nBudget67 = nResult67;

    // let nPercent65 = (nResult65 / nBudget65) * 100;
    // let nPercent66 = (nResult66 / nBudget66) * 100;
    // let nPercent67 = (nResult67 / nBudget67) * 100;

    // const arrInitExpensesBox = [
    //     {
    //         nYear: 2565,
    //         sBudget: nBudget65.toLocaleString('en-US', {
    //             minimumFractionDigits: nResult65 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sResult: (nResult65).toLocaleString('en-US', {
    //             minimumFractionDigits: nResult65 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sPercent: (nPercent65).toLocaleString('en-US', {
    //             maximumFractionDigits: 2
    //         }) + "%"
    //     },
    //     {
    //         nYear: 2566,
    //         sBudget: nBudget66.toLocaleString('en-US', {
    //             minimumFractionDigits: nBudget66 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sResult: (nResult66).toLocaleString('en-US', {
    //             minimumFractionDigits: nResult66 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sPercent: (nPercent66).toLocaleString('en-US', {
    //             maximumFractionDigits: 2
    //         }) + "%"
    //     },
    //     {
    //         nYear: 2567,
    //         sBudget: nBudget67.toLocaleString('en-US', {
    //             minimumFractionDigits: nBudget67 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sResult: (nResult67).toLocaleString('en-US', {
    //             minimumFractionDigits: nResult67 % 1 === 0 ? 0 : 2,
    //             maximumFractionDigits: 2
    //         }),
    //         sPercent: (nPercent67).toLocaleString('en-US', {
    //             maximumFractionDigits: 2
    //         }) + "%"
    //     }
    // ];

    const arrInitExpensesBox = useMemo(() => {
        if (!data) { return [] }
        let lstNew = [];
        let lstResult = _.cloneDeep(data.lstDataExpenseActualSummary) || [];
        let lstPlan = _.cloneDeep(data.lstDataExpensePlanSummary) || [];
        arrYear.forEach(year => {

            let sBudget = lstPlan.filter(f => f.nYear === year).reduce((acc, obj) => acc + obj.nValue, 0);
            let sResult = lstResult.filter(f => f.nYear === year).reduce((acc, obj) => acc + obj.nValue, 0);
            let nPercent = (sResult / sBudget) * 100;

            let objNew = {
                nYear: year + 543,
                sBudget: sBudget.toLocaleString('en-US', {
                    minimumFractionDigits: sBudget % 1 === 0 ? 0 : 2,
                    maximumFractionDigits: 2
                }),
                sResult: (sResult).toLocaleString('en-US', {
                    minimumFractionDigits: sResult % 1 === 0 ? 0 : 2,
                    maximumFractionDigits: 2
                }),
                sPercent: (isNaN(nPercent) ? 0 : (nPercent).toLocaleString('en-US', {
                    // minimumFractionDigits: Number.isInteger(nPercent) ? 0 : 2,
                    maximumFractionDigits: 2
                })) + "%"
            };
            lstNew.push(objNew);
        });

        return lstNew;
    }, [data]);

    const arrInitPlanExpensesLineChart = useMemo(() => {
        if (!data) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(data.lstDataExpensePlanSummary) || [];
        lstData.forEach(ele => {
            let objNew = {};
            objNew["sMonth"] = ele.sMonth;
            let sField = "Y" + (ele.nYear + 543);
            objNew[sField] = ele.sValue; //เปลี่ยนเป็น ล้านบาท //ele.nValue;
            lstNew.push(objNew);
        });

        return lstNew;
    }, [data]);

    // const arrInitPlanExpensesLineChart = [
    //     {
    //         "sMonth": "ม.ค.",
    //         "Y2565": "2.5",
    //         "Y2566": "1.5",
    //         "Y2567": "3.4"
    //     },
    //     {
    //         "sMonth": "ก.พ.",
    //         "Y2565": "0.5",
    //         "Y2566": "1.8",
    //         "Y2567": "1.1"
    //     },
    //     {
    //         "sMonth": "มี.ค.",
    //         "Y2565": "1.4",
    //         "Y2566": "0.3",
    //         "Y2567": "1.8"
    //     },
    //     {
    //         "sMonth": "เม.ย.",
    //         "Y2565": "1.7",
    //         "Y2566": "0.7",
    //         "Y2567": "2.8"
    //     },
    //     {
    //         "sMonth": "พ.ค.",
    //         "Y2565": "0.94",
    //         "Y2566": "1.8",
    //         "Y2567": "0.4"
    //     },
    //     {
    //         "sMonth": "มิ.ย.",
    //         "Y2565": "2.5",
    //         "Y2566": "2.1",
    //         "Y2567": "1.6"
    //     },
    //     {
    //         "sMonth": "ก.ค.",
    //         "Y2565": "0.6",
    //         "Y2566": "1.6",
    //         "Y2567": "2.4"
    //     },
    //     {
    //         "sMonth": "ส.ค.",
    //         "Y2565": "1",
    //         "Y2566": "1.7",
    //         "Y2567": "2.1"
    //     },
    //     {
    //         "sMonth": "ก.ย.",
    //         "Y2565": "0.6",
    //         "Y2566": "2",
    //         "Y2567": "1"
    //     },
    //     {
    //         "sMonth": "ต.ค.",
    //         "Y2565": "0.8",
    //         "Y2566": "1.7",
    //         "Y2567": "0.01"
    //     },
    //     {
    //         "sMonth": "พ.ย.",
    //         "Y2565": "1.9",
    //         "Y2566": "1",
    //         "Y2567": "1.4"
    //     },
    //     {
    //         "sMonth": "ธ.ค.",
    //         "Y2565": "0.09",
    //         "Y2566": "1",
    //         "Y2567": "1.5"
    //     }
    // ];

    // const arrSection = [
    //     {
    //         nYear: 2565,
    //         sTitle: "รายจ่ายรวมปี 2565",
    //         nOrder: 1,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "มาตรา 40(1)",
    //                 nValue: 78349,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "มาตรา 40(2)",
    //                 nValue: 92563,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "มาตรา 40(3)",
    //                 nValue: 61748,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "มาตรา 40(4)",
    //                 nValue: 30587,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "มาตรา 40(5)",
    //                 nValue: 48923,
    //                 nOrder: 5
    //             }
    //         ]
    //     },
    //     {
    //         nYear: 2566,
    //         sTitle: "รายจ่ายรวมปี 2566",
    //         nOrder: 2,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "มาตรา 40(1)",
    //                 nValue: 34891,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "มาตรา 40(2)",
    //                 nValue: 82675,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "มาตรา 40(3)",
    //                 nValue: 17429,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "มาตรา 40(4)",
    //                 nValue: 69532,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "มาตรา 40(5)",
    //                 nValue: 41287,
    //                 nOrder: 5
    //             }
    //         ]
    //     },
    //     {
    //         nYear: 2567,
    //         sTitle: "รายจ่ายรวมปี 2567",
    //         nOrder: 1,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "มาตรา 40(1)",
    //                 nValue: 93125,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "มาตรา 40(2)",
    //                 nValue: 60873,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "มาตรา 40(3)",
    //                 nValue: 24786,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "มาตรา 40(4)",
    //                 nValue: 52941,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "มาตรา 40(5)",
    //                 nValue: 87354,
    //                 nOrder: 5
    //             }
    //         ]
    //     }
    // ]

    const arrSection = useMemo(() => {
        if (!data) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(data.lstPieChartSectionByYear) || [];
        lstData.forEach(ele => {
            let objNew = {
                nYear: ele.nYear + 543,
                sTitle: ele.sTitle,
                nOrder: ele.nOrder,
                lstData: [...ele.lstData]
            };
            lstNew.push(objNew);
        });

        return lstNew;
    }, [data]);

    const arrSection5 = useMemo(() => {
        if (!data) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(data.lstPieChartBySection5) || [];
        lstData.forEach(ele => {
            let objNew = {
                nYear: ele.nYear + 543,
                sTitle: ele.sTitle,
                nOrder: ele.nOrder,
                lstData: [...ele.lstData]
            };
            lstNew.push(objNew);
        });

        return lstNew;
    }, [data]);

    const arrInitExpensesLineChart = useMemo(() => {
        if (!data) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(data.lstDataExpenseActualSummary) || [];
        lstData.forEach(ele => {
            let objNew = {};
            objNew["sMonth"] = ele.sMonth;
            let sField = "Y" + (ele.nYear + 543);
            objNew[sField] = ele.sValue; //เปลี่ยนเป็น ล้านบาท //ele.nValue;
            lstNew.push(objNew);
        });

        return lstNew;
    }, [data]);

    // const arrSection5 = [
    //     {
    //         nYear: 2565,
    //         sTitle: "มาตรา 40(5) ปี 2565",
    //         nOrder: 1,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "งบบุคลากร",
    //                 nValue: 27834,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "ค่าตอบแทน",
    //                 nValue: 96157,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "ค่าใช้สอย",
    //                 nValue: 53784,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "ค่าวัสดุ",
    //                 nValue: 48591,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "ค่าสาธารณูปโภค",
    //                 nValue: 32679,
    //                 nOrder: 5
    //             },
    //             {
    //                 nID: 6,
    //                 sName: "สิ่งก่อสร้าง",
    //                 nValue: 74082,
    //                 nOrder: 6
    //             },
    //             {
    //                 nID: 7,
    //                 sName: "ครุภัณฑ์",
    //                 nValue: 50296,
    //                 nOrder: 7
    //             }
    //         ]
    //     },
    //     {
    //         nYear: 2566,
    //         sTitle: "มาตรา 40(5) ปี 2566",
    //         nOrder: 2,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "งบบุคลากร",
    //                 nValue: 38291,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "ค่าตอบแทน",
    //                 nValue: 56978,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "ค่าใช้สอย",
    //                 nValue: 20567,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "ค่าวัสดุ",
    //                 nValue: 79841,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "ค่าสาธารณูปโภค",
    //                 nValue: 12453,
    //                 nOrder: 5
    //             },
    //             {
    //                 nID: 6,
    //                 sName: "สิ่งก่อสร้าง",
    //                 nValue: 90473,
    //                 nOrder: 6
    //             },
    //             {
    //                 nID: 7,
    //                 sName: "ครุภัณฑ์",
    //                 nValue: 63519,
    //                 nOrder: 7
    //             }
    //         ]
    //     },
    //     {
    //         nYear: 2567,
    //         sTitle: "มาตรา 40(5) ปี 2567",
    //         nOrder: 1,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "งบบุคลากร",
    //                 nValue: 58732,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "ค่าตอบแทน",
    //                 nValue: 14259,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "ค่าใช้สอย",
    //                 nValue: 93681,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "ค่าวัสดุ",
    //                 nValue: 40982,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "ค่าสาธารณูปโภค",
    //                 nValue: 72415,
    //                 nOrder: 5
    //             },
    //             {
    //                 nID: 6,
    //                 sName: "สิ่งก่อสร้าง",
    //                 nValue: 29873,
    //                 nOrder: 6
    //             },
    //             {
    //                 nID: 7,
    //                 sName: "ครุภัณฑ์",
    //                 nValue: 81694,
    //                 nOrder: 7
    //             }
    //         ]
    //     }
    // ]

    return { arrInitExpensesLineChart, arrInitExpensesBox, arrInitPlanExpensesLineChart, arrSection, arrSection5 };
}

export function useInitYearlyExpenses({ data }) {

    const arrColorList = ["#a989b2", "#c590b1", "#E7B8D9", "#ffccdc", "#FFE8B6"];
    const arrColorListExpense = ["#F45F5F", "#F1C835", "#47DDC1", "#29b1f0", "#425af5", "#6934ed", "#7c1de0", "#aa14c4", "#cc37ae", "#db2a8e", "#f51b67", "#a32f2f"];

    // const arrSectionPlan = [
    //     {
    //         nID: 1,
    //         sSectionShort: "40(1)",
    //         nPlan: 78000,
    //         nActual: 66300,
    //         nPercent: (66300 / 78000) * 100,
    //         nOrder: 1
    //     },
    //     {
    //         nID: 2,
    //         sSectionShort: "40(2)",
    //         nPlan: 95000,
    //         nActual: 75000,
    //         nPercent: (75000 / 95000) * 100,
    //         nOrder: 2
    //     },
    //     {
    //         nID: 3,
    //         sSectionShort: "40(3)",
    //         nPlan: 65000,
    //         nActual: 65000,
    //         nPercent: 100,
    //         nOrder: 3
    //     },
    //     {
    //         nID: 4,
    //         sSectionShort: "40(4)",
    //         nPlan: 30000,
    //         nActual: 18600,
    //         nPercent: (18600 / 30000) * 100,
    //         nOrder: 4
    //     },
    //     {
    //         nID: 5,
    //         sSectionShort: "40(5)",
    //         nPlan: 145000,
    //         nActual: 143550,
    //         nPercent: (143550 / 145000) * 100,
    //         nOrder: 5
    //     }
    // ]

    const arrSectionPlan = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstSectionSummary) || [];
        return lstNew;
    }, [data]);

    const arrExpenseSummary = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstExpenseSummary) || [];
        return lstNew;
    }, [data]);

    const arrSectionProject = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstDataExpenseProject) || [];
        return lstNew;
    }, [data]);
    
    const arrExpense4 = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstSummaryStackSection) || [];
        return lstNew;
    }, [data]);

    const arrExpense5 = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstSummaryStackSection5) || [];
        return lstNew;
    }, [data]);

    const arrExpenseFundItemActivity = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstExpenseFundItemActivity) || [];
        return lstNew;
    }, [data]);

    const lstYearTable = useMemo(() => {
        if (!data) { return [] }
        let lstNew = _.cloneDeep(data.lstYear).map(m => m + 543) || [];
        return lstNew;
    }, [data]);

    // const arrSectionProject = [
    //     {
    //         nID: 2565,
    //         sTitle: "40(1)",
    //         nOrder: 1,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "โครงการการศึกษาซากดึกดำบรรพ์ จระเข้ยักษ์วงศ์โฟลิโดซอริตี้ ในจังหวัดชัยภูมิเพื่อความเข้าใจด้านวิวัฒนาการบรรพชีวภูมิศาสตร์และการกระจายตัวในยุคครีเทเซียสของประเทศไทย",
    //                 nValue: 78349,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "โครงการการศึกษาวิจัยซากดึกดำบรรพ์ หอยฝาเดียวในแหล่งชากดึกดำบรรพ์ภูน้ำหยด ตำบลภูน้ำหยด อำเภอวิเชียรบุรี จังหวัดเพชรบูรณ์",
    //                 nValue: 92563,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "โครงการความหลากหลายทาง ขั้วภาพของชากดึกดำบรรพ์ฟองน้ำและไบรโอชั่วในแหล่งชากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์",
    //                 nValue: 61748,
    //                 nOrder: 3
    //             }
    //         ]
    //     },
    //     {
    //         nID: 2566,
    //         sTitle: "40(2)",
    //         nOrder: 2,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "โครงการการศึกษาซากดึกดำบรรพ์ จระเข้ยักษ์วงศ์โฟลิโดซอริตี้ ในจังหวัดชัยภูมิเพื่อความเข้าใจด้านวิวัฒนาการบรรพชีวภูมิศาสตร์และการกระจายตัวในยุคครีเทเซียสของประเทศไทย",
    //                 nValue: 56800,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "โครงการการศึกษาวิจัยซากดึกดำบรรพ์ หอยฝาเดียวในแหล่งชากดึกดำบรรพ์ภูน้ำหยด ตำบลภูน้ำหยด อำเภอวิเชียรบุรี จังหวัดเพชรบูรณ์",
    //                 nValue: 45800,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "โครงการความหลากหลายทาง ขั้วภาพของชากดึกดำบรรพ์ฟองน้ำและไบรโอชั่วในแหล่งชากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์",
    //                 nValue: 65000,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "โครงการเมืองประวัติศาสตร์สุโขทัยและเมืองบริวาร",
    //                 nValue: 45000,
    //                 nOrder: 3
    //             }
    //         ]
    //     },
    //     {
    //         nID: 2567,
    //         sTitle: "40(3)",
    //         nOrder: 3,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "โครงการการศึกษาซากดึกดำบรรพ์ จระเข้ยักษ์วงศ์โฟลิโดซอริตี้ ในจังหวัดชัยภูมิเพื่อความเข้าใจด้านวิวัฒนาการบรรพชีวภูมิศาสตร์และการกระจายตัวในยุคครีเทเซียสของประเทศไทย",
    //                 nValue: 35000,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "โครงการการศึกษาวิจัยซากดึกดำบรรพ์ หอยฝาเดียวในแหล่งชากดึกดำบรรพ์ภูน้ำหยด ตำบลภูน้ำหยด อำเภอวิเชียรบุรี จังหวัดเพชรบูรณ์",
    //                 nValue: 25000,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "โครงการความหลากหลายทาง ขั้วภาพของชากดึกดำบรรพ์ฟองน้ำและไบรโอชั่วในแหล่งชากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์",
    //                 nValue: 45600,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "โครงการแหล่งโบราณคดีบ้านเชียง",
    //                 nValue: 15000,
    //                 nOrder: 4
    //             }
    //         ]
    //     },
    //     {
    //         nID: 2568,
    //         sTitle: "40(4)",
    //         nOrder: 4,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "โครงการการศึกษาซากดึกดำบรรพ์ จระเข้ยักษ์วงศ์โฟลิโดซอริตี้ ในจังหวัดชัยภูมิเพื่อความเข้าใจด้านวิวัฒนาการบรรพชีวภูมิศาสตร์และการกระจายตัวในยุคครีเทเซียสของประเทศไทย",
    //                 nValue: 76900,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "โครงการการศึกษาวิจัยซากดึกดำบรรพ์ หอยฝาเดียวในแหล่งชากดึกดำบรรพ์ภูน้ำหยด ตำบลภูน้ำหยด อำเภอวิเชียรบุรี จังหวัดเพชรบูรณ์",
    //                 nValue: 87000,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "โครงการความหลากหลายทาง ขั้วภาพของชากดึกดำบรรพ์ฟองน้ำและไบรโอชั่วในแหล่งชากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์",
    //                 nValue: 38000,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "โครงการอนุสรณ์สถานแหล่งต่าง ๆ และภูมิทัศน์วัฒนธรรมของเชียงใหม่ นครหลวงล้านนา",
    //                 nValue: 90000,
    //                 nOrder: 4
    //             },
    //             {
    //                 nID: 5,
    //                 sName: "โครงการกลุ่มป่าดงพญาเย็น-เขาใหญ่",
    //                 nValue: 40000,
    //                 nOrder: 5
    //             },
    //             {
    //                 nID: 6,
    //                 sName: "โครงการเมืองโบราณศรีเทพ และโบราณสถานสมัยทวารวดีที่เกี่ยวข้อง",
    //                 nValue: 65000,
    //                 nOrder: 6
    //             }
    //         ]
    //     },
    //     {
    //         nID: 2569,
    //         sTitle: "40(5)",
    //         nOrder: 5,
    //         lstData: [
    //             {
    //                 nID: 1,
    //                 sName: "โครงการการศึกษาซากดึกดำบรรพ์ จระเข้ยักษ์วงศ์โฟลิโดซอริตี้ ในจังหวัดชัยภูมิเพื่อความเข้าใจด้านวิวัฒนาการบรรพชีวภูมิศาสตร์และการกระจายตัวในยุคครีเทเซียสของประเทศไทย",
    //                 nValue: 95000,
    //                 nOrder: 1
    //             },
    //             {
    //                 nID: 2,
    //                 sName: "โครงการการศึกษาวิจัยซากดึกดำบรรพ์ หอยฝาเดียวในแหล่งชากดึกดำบรรพ์ภูน้ำหยด ตำบลภูน้ำหยด อำเภอวิเชียรบุรี จังหวัดเพชรบูรณ์",
    //                 nValue: 45000,
    //                 nOrder: 2
    //             },
    //             {
    //                 nID: 3,
    //                 sName: "โครงการความหลากหลายทาง ขั้วภาพของชากดึกดำบรรพ์ฟองน้ำและไบรโอชั่วในแหล่งชากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์",
    //                 nValue: 78900,
    //                 nOrder: 3
    //             },
    //             {
    //                 nID: 4,
    //                 sName: "โครงการตรวจสอบซากดึกดำบรรพ์ บ้านโป่งมะนาว จังหวัดลพบุรี",
    //                 nValue: 90000,
    //                 nOrder: 4
    //             }, {
    //                 nID: 5,
    //                 sName: "แหล่งโบราณคดี นครประวัติศาสตร์พระนครศรีอยุธยา",
    //                 nValue: 65000,
    //                 nOrder: 5
    //             }
    //         ]
    //     }
    // ]

    // const arrExpense5 = [
    //     {
    //         "sMonth": "ม.ค.",
    //         "nYear": "2563",
    //         "nActual": 94000,
    //         "nValue": 94300,
    //     },
    //     {
    //         "sMonth": "ก.พ.",
    //         "nYear": "2564",
    //         "nActual": 80000,
    //         "nValue": 83000,
    //     },
    //     {
    //         "sMonth": "มี.ค.",
    //         "nYear": "2565",
    //         "nActual": 75900,
    //         "nValue": 80700,
    //     },
    //     {
    //         "sMonth": "เม.ย.",
    //         "nYear": "2565",
    //         "nActual": 72000,
    //         "nValue": 75600,
    //     },
    //     {
    //         "sMonth": "พ.ค.",
    //         "nYear": "2565",
    //         "nActual": 12000,
    //         "nValue": 146900,
    //     },
    //     {
    //         "sMonth": "มิ.ย.",
    //         "nYear": "2565",
    //         "nActual": 246000,
    //         "nValue": 247000,
    //     },
    //     {
    //         "sMonth": "ก.ค.",
    //         "nYear": "2565",
    //         "nActual": 150000,
    //         "nValue": 179900,
    //     },
    //     {
    //         "sMonth": "ส.ค.",
    //         "nYear": "2565",
    //         "nActual": 192500,
    //         "nValue": 196000,
    //     },
    //     {
    //         "sMonth": "ก.ย.",
    //         "nYear": "2565",
    //         "nActual": 125000,
    //         "nValue": 125000,
    //     },
    //     {
    //         "sMonth": "ต.ค.",
    //         "nYear": "2565",
    //         "nActual": 90000,
    //         "nValue": 175000,
    //     },
    //     {
    //         "sMonth": "พ.ย.",
    //         "nYear": "2565",
    //         "nActual": 93000,
    //         "nValue": 95000,
    //     },
    //     {
    //         "sMonth": "ธ.ค.",
    //         "nYear": "2565",
    //         "nActual": 134900,
    //         "nValue": 135000,
    //     },
    // ]

    const arrExpense5Line = [
        {
            value: "1",
            label: "รายจ่ายปรับแผนงาน (บาท)",
            sValue: "nValue"
        }
    ]

    // const arrExpense4 = [
    //     {
    //         "sMonth": "ม.ค.",
    //         "nYear": "2563",
    //         "nActual": 530000,
    //         "nValue": 520600,
    //     },
    //     {
    //         "sMonth": "ก.พ.",
    //         "nYear": "2564",
    //         "nActual": 890000,
    //         "nValue": 80000,
    //     },
    //     {
    //         "sMonth": "มี.ค.",
    //         "nYear": "2565",
    //         "nActual": 350000,
    //         "nValue": 310700,
    //     },
    //     {
    //         "sMonth": "เม.ย.",
    //         "nYear": "2565",
    //         "nActual": 730000,
    //         "nValue": 720100,
    //     },
    //     {
    //         "sMonth": "พ.ค.",
    //         "nYear": "2565",
    //         "nActual": 450000,
    //         "nValue": 430300,
    //     },
    //     {
    //         "sMonth": "มิ.ย.",
    //         "nYear": "2565",
    //         "nActual": 245000,
    //         "nValue": 180900,
    //     },
    //     {
    //         "sMonth": "ก.ค.",
    //         "nYear": "2565",
    //         "nActual": 700000,
    //         "nValue": 640500,
    //     },
    //     {
    //         "sMonth": "ส.ค.",
    //         "nYear": "2565",
    //         "nActual": 800000,
    //         "nValue": 790800,
    //     },
    //     {
    //         "sMonth": "ก.ย.",
    //         "nYear": "2565",
    //         "nActual": 1000000,
    //         "nValue": 970400,
    //     },
    //     {
    //         "sMonth": "ต.ค.",
    //         "nYear": "2565",
    //         "nActual": 300000,
    //         "nValue": 250200,
    //     },
    //     {
    //         "sMonth": "พ.ย.",
    //         "nYear": "2565",
    //         "nActual": 900000,
    //         "nValue": 860000,
    //     },
    //     {
    //         "sMonth": "ธ.ค.",
    //         "nYear": "2565",
    //         "nActual": 650000,
    //         "nValue": 580000,
    //     },
    // ]

    const arrExpense4Line = [
        {
            value: "1",
            label: "รายจ่ายปรับแผนงาน (บาท)",
            sValue: "nValue"
        }
    ]

    return { lstYearTable, arrColorListExpense, arrColorList, arrExpenseSummary, arrSectionPlan, arrSectionProject, arrExpense5, arrExpense5Line, arrExpense4, arrExpense4Line, arrExpenseFundItemActivity };
}

export function useInitExpensesDashboard() {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const [arrYear, setArrYear] = useState([]);
    const [arrSection, setArrSection] = useState([]);
    const [option, setOption] = useState({
        lstYear: [],
        lstSection: []
    });

    const [arrMonth, setArrMonth] = useState([]);
    const [isCheckYear, setIsCheckYear] = useState(false);
    const [nYear, setNYear] = useState(moment().year());

    const [cancelToken, setCancelToken] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [arrResult, setArrResult] = useState({});

    // const [option, setOption] = useState({
    //     lstYear: [{ value: "1", label: "2567" }, { value: "2", label: "2566" }, { value: "3", label: "2565" }, { value: "4", label: "2564" }],
    //     lstSection: [{ value: "1", label: "40 (1)" }, { value: "2", label: "40 (2)" }, { value: "3", label: "40 (3)" }, { value: "4", label: "40 (4)" }, { value: "5", label: "40 (5)" }]
    // })

    // const [arrYear, setArrYear] = useState(option.lstYear.filter(f => parseInt(f.value) < 4).map(m => m.value))
    // const [arrSection, setArrSection] = useState(option.lstSection.map(m => m.value))

    useEffect(() => {
        const myParamsSerializer = (params) => {
            const serializedParams = Object.keys(params)
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
                .join('&');

            return serializedParams;
        };

        const fetchData = async () => {

            try {
                if (cancelToken) {
                    setIsLoading(false)
                    cancelToken.cancel();
                }

                const source = axios.CancelToken.source();
                setCancelToken(source);

                const authToken = secureLocalStorage.getItem(`${process.env.REACT_APP_JWT_KEY}`);
                const ConfigJwt = {
                    Authorization: IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
                    Accept: "application/json",
                    "Content-Type": "application/json"
                };

                const baseUrl = process.env.REACT_APP_API_URL;
                const sPathApi = `${baseUrl}api/ExpenseDashboard/GetDataCompareYear`;
                const url = new URL(sPathApi, window.location.href);
                const sNewPath = url.origin + url.pathname + url.search;

                let oFilter = {
                    lstFilterYear: isCheckYear ? [nYear] : arrYear,
                    lstFilterSectionID: arrSection,
                    lstFilterMonth: [...arrMonth].map(m => parseInt(m)),
                    isFilterByYear: isCheckYear
                }

                DialogFn.BlockUI();
                setIsLoading(true)
                await axios.post(sNewPath, oFilter, {
                    headers: ConfigJwt,
                    cancelToken: source.token,
                    paramsSerializer: myParamsSerializer
                })
                    .then((response) => {
                        setIsLoading(false);
                        let objResult = response.data;
                        setArrResult(objResult);
                        DialogFn.UnBlockUI();
                    })
                    .catch((error) => {
                        DialogFn.UnBlockUI();
                        if (axios.isCancel(error)) return;
                    });
            } catch (error) {
                DialogFn.UnBlockUI();
            }
        };

        fetchData();

        return () => {
            if (cancelToken) {
                cancelToken.cancel('Component unmounted');
            }
        };
    }, [arrMonth, arrYear, isCheckYear, nYear, arrSection]);


    useEffect(() => {
        getInitial();
    }, [])

    const getInitial = () => {
        AxiosFn.Get(`ExpenseDashboard/GetMasterOption`, {}, (result) => {
            setArrYear([...result.lstYear].map(m => m.value).slice(0, 3));
            setArrSection([...result.lstSection].map(m => m.value));
            setOption(result);
        })
    }
    return { arrResult, option, arrYear, arrSection, setArrYear, setArrSection, arrMonth, setArrMonth, isCheckYear, setIsCheckYear, nYear, setNYear };
}